import {resolveApiBaseURL} from '@infrastructure';
import {UserImageHash, useUserProfilePicsWithBaseUrl} from '@lib/logic';

export const useUserProfilePics = (userImageHashes: UserImageHash[], size = 64) =>
  useUserProfilePicsWithBaseUrl(resolveApiBaseURL(), userImageHashes, size);
